import { updateCompostionActionTypes, updatingComposition, updatedComposition, loadCompositionEpicReducer, resetCompositionEdit, navigateToComposition, compositionEditActionTypes, navigatedToComposition, loadDependencyEpicReducer, queryFlightEpicReducer } from "./Composition.ducks.js";
import * as ReduxObservablesEpicUtils from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import { getTenantFromManagementGroup } from "@ane/exp-data/lib/utils/ManagementGroup";
import CompositionResource from "../../resources/Composition.resource.js";
import { getCompletedAsyncWrapperObj } from "@ane/core/lib/models/IAsyncWrapper";
import { convertFlightDependencies, isResultBlocking, getSubmissionResultMessage, resultBlockingMessage } from "./CompositionEdit/CompositionEdit.utils.js";
import { of } from "rxjs";
import { ofType, combineEpics } from "redux-observable";
import { mergeMap } from "rxjs/operators";
import "../../../../utils/FlightRoute.utils.js";
import { toggleCompositionEditView } from "@ane/exp-data/lib/routes/FlightRoute.utils";
const updateCompositionArgs = {
  filterOnType: updateCompostionActionTypes.UPDATE,
  loadResource: (payload, state) => {
    const { managementGroup, workspaceId, verifyOnly, submitWithBlocking, request } = payload;
    return CompositionResource.updateCompositionBatch(
      managementGroup,
      getTenantFromManagementGroup(managementGroup),
      workspaceId,
      request,
      verifyOnly,
      submitWithBlocking
    );
  },
  loadingAction: updatingComposition,
  ensureSuccess: false,
  loadedAction: (successData, payload, error, errorContext) => {
    const result = successData ? convertFlightDependencies(payload.flightId, successData) : null;
    const isVerificationSuccess = !isResultBlocking(successData);
    if (!error && !payload.verifyOnly) {
      const submissionMessage = !payload.verifyOnly ? getSubmissionResultMessage(isVerificationSuccess, resultBlockingMessage(successData)) : null;
      return of(
        updatedComposition(payload, getCompletedAsyncWrapperObj(result, error || ""), isVerificationSuccess, submissionMessage),
        loadCompositionEpicReducer.actionCreators.load({
          flightId: payload.flightId,
          managementGroup: payload.managementGroup,
          workspaceId: payload.workspaceId
        }),
        resetCompositionEdit(payload.flightId),
        navigateToComposition(payload.flightId, payload.managementGroup, payload.workspaceId)
      );
    } else {
      return of(
        updatedComposition(payload, getCompletedAsyncWrapperObj(result, error || "", errorContext), isVerificationSuccess, null)
      );
    }
  }
};
const updateCompositionEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(updateCompositionArgs);
const navigateToCompositionEpic = (action$) => {
  return action$.pipe(
    ofType(compositionEditActionTypes.NAVIGATE_TO_COMPOSITION),
    mergeMap((action) => {
      const { flightId, managementGroup, workspaceId } = action.payload;
      toggleCompositionEditView(flightId, workspaceId, managementGroup, false);
      return of(navigatedToComposition());
    })
  );
};
const FlightCompositionEpics = combineEpics(
  loadCompositionEpicReducer.epic,
  loadDependencyEpicReducer.epic,
  queryFlightEpicReducer.epic,
  updateCompositionEpic,
  navigateToCompositionEpic
);
export {
  FlightCompositionEpics as default,
  navigateToCompositionEpic,
  updateCompositionEpic
};
//# sourceMappingURL=Composition.epics.js.map
